import "./navbar.scss";

const hamburger = document.getElementById('hamburger');
if (hamburger !== null) {
  hamburger.addEventListener('click', function () {
    hamburger.classList.toggle('change');
  });
}
